import React, { useState } from 'react';
import { Icon, IconButton, useMediaQuery } from '@material-ui/core';
import { useAuth } from '@domain/auth/auth.hook';
import { useTheme } from '@material-ui/core/styles';
import UserMenu from '@components/app.chrome/user.menu';
import { UserNameContainer } from '@components/app.chrome/user.menu.button.styles';

const UserMenuButton = () => {
  const { user, signOut } = useAuth();
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState<Element | null>(null);

  const theme = useTheme();
  const showUser = useMediaQuery(theme.breakpoints.up('sm'));

  const openUserMenu = (event: React.MouseEvent<HTMLElement, MouseEvent>) => setUserMenuAnchorEl(event.currentTarget);
  const closeUserMenu = () => setUserMenuAnchorEl(null);

  const handleSignOut = () => {
    closeUserMenu();
    signOut();
  };

  return (
    <>
      <IconButton color='inherit' aria-label='user menu' aria-controls='user-menu' aria-haspopup='true' onClick={openUserMenu}>
        {showUser && <UserNameContainer>{user?.username}</UserNameContainer>}
        <Icon>account_circle</Icon>
      </IconButton>
      <UserMenu anchorEl={userMenuAnchorEl} onClearAnchor={closeUserMenu} signOut={handleSignOut} />
    </>
  );
};

export default UserMenuButton;
